import { createModalStore } from '@/shared/lib/modal';

import type { TrialPlan } from './PLANS';

type TrialPaywallState = {
  title?: string;
  allowedPlanNames?: null | TrialPlan['name'][];
  preSelectedPlanName?: null | TrialPlan['name'];
};

const initialState: TrialPaywallState = {
  title: undefined,
  allowedPlanNames: null,
  preSelectedPlanName: null,
};

export const useTrialPaywallModalStore = createModalStore<TrialPaywallState>(initialState);
